import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const theme = useTheme();
  const navigate = useNavigate();

  const navigateHome = () => {
    navigate("/");
  };

  return (
    <HeaderContainer>
      <LogoWrapper onClick={navigateHome}>
        <Image
          src={theme.image.logo_black.default}
          width="140px"
          height="100%"
        />
      </LogoWrapper>
    </HeaderContainer>
  );
}

const HeaderContainer = styled.header(
  () =>
    ({
      position: "sticky",
      top: 0,
      zIndex: 1000,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: "56px",
      padding: "2.1rem 2rem",
    }) as const,
);

const LogoWrapper = styled.div({
  paddingBottom: "2px",
  cursor: "pointer",
});
